import { Box, Dialog, Portal, Table, Text, VStack } from '@chakra-ui/react';
import { ReactComponent as DownIcon } from 'assets/icons/chevron-down.svg';
import { ReactComponent as TransferIcon } from 'assets/icons/transfer.svg';
import { useTranslation } from 'localization';

import {
  Button,
  DIALOG_ACTION_BUTTON_PROPS,
  ServiceDialogBody,
  ServiceDialogCloseTrigger,
  ServiceDialogFooter,
  ServiceDialogHeader,
  serviceDialogShellProps,
} from 'components';

type ApproveModalType = {
  onClose: () => void;
  isOpen: boolean;
  loading: boolean;
  data: { amount: number; fee: number };
  onButton: () => void;
};

const ApproveModal: React.FC<ApproveModalType> = ({
  onClose,
  isOpen,
  data,
  loading,
  onButton,
}: ApproveModalType) => {
  const { t } = useTranslation('component.transfer.modal');

  const feeAmount = (data.amount * data.fee) / 100;

  return (
    <Box display="flex" alignItems="center">
      <Dialog.Root
        size="xl"
        open={isOpen}
        placement="center"
        onOpenChange={(e: { open: boolean }) => {
          if (!e.open) {
            onClose();
          }
        }}
      >
        <Portal>
          <Dialog.Backdrop />
          <Dialog.Positioner>
            <Dialog.Content {...serviceDialogShellProps({ maxW: 'xl' })}>
              <ServiceDialogHeader>{t('confirm')}</ServiceDialogHeader>
              <ServiceDialogCloseTrigger />
              <ServiceDialogBody py={6} px={4}>
                <VStack
                  align="center"
                  justify="space-between"
                  h="100%"
                  w="100%"
                >
                  <VStack w="100%" align="center" justify="center">
                    <TransferIcon />
                    <Text fontSize="4xl" fontWeight="500" color="gray" py={2}>
                      $ {data.amount}
                    </Text>
                    <DownIcon />
                    <Text fontSize="4xl" fontWeight="500">
                      $ {data.amount - feeAmount}
                    </Text>
                  </VStack>
                  <Table.ScrollArea w="100%" overflowX="auto">
                    <Table.Root variant="line">
                      <Table.Body>
                        <Table.Row>
                          <Table.Cell textAlign="left">{t('fee')}</Table.Cell>
                          <Table.Cell textAlign="right">
                            {data.fee ? '% ' + data.fee : '0'}
                          </Table.Cell>
                        </Table.Row>
                      </Table.Body>
                    </Table.Root>
                  </Table.ScrollArea>
                </VStack>
              </ServiceDialogBody>
              <ServiceDialogFooter>
                <Button
                  w="100%"
                  variant="filled"
                  title={t('confirm')}
                  isLoading={loading}
                  onClick={() => onButton()}
                  {...DIALOG_ACTION_BUTTON_PROPS}
                />
              </ServiceDialogFooter>
            </Dialog.Content>
          </Dialog.Positioner>
        </Portal>
      </Dialog.Root>
    </Box>
  );
};

export default ApproveModal;
